import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-back-button-wtih-state',
  templateUrl: './back-button-wtih-state.component.html',
  styleUrls: ['./back-button-wtih-state.component.css']
})
export class BackButtonWtihStateComponent implements OnInit {

  constructor(  public location: Location) { }

  ngOnInit(): void {
  }

  backButtonWithState() {
    return this.location.back();
  }

}
